'use client';

import { FC, useRef, useState } from 'react';
import { CarouselContainer, StyledButton } from './styled';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper/types';
import 'swiper/css';
import 'swiper/css/navigation';

import { Navigation } from 'swiper/modules';
import { HousingCard } from '@/components';
import { IHousingObjectResponse } from '@/types';
import { SwiperArrowLeft, SwiperArrowRight } from '@/components';

type CarouselProps = {
  data: IHousingObjectResponse[];
};

export const Carousel: FC<CarouselProps> = ({ data }) => {
  const swiperRef = useRef<SwiperType>(null);

  const [IsEnd, setIsEnd] = useState(false);
  const [isBeginning, setIsBeginning] = useState(false);

  const handleSlideChange = (swiper: SwiperType) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <CarouselContainer>
      <StyledButton
        variant="outlined"
        disabled={isBeginning}
        onClick={() => swiperRef.current?.slidePrev()}
        className="navigation-button left"
        aria-label="Previous slide"
      >
        <SwiperArrowLeft width={24} height={24} aria-hidden="true" />
      </StyledButton>

      <Swiper
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
          handleSlideChange(swiper);
        }}
        onSlideChange={handleSlideChange}
        navigation={false}
        modules={[Navigation]}
        initialSlide={0}
        className="mySwiper"
        spaceBetween={24}
        autoHeight
        breakpoints={{
          1023: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          768: {
            slidesPerView: 2.2,
            slidesPerGroup: 2,
          },
          0: {
            slidesPerView: 1.2,
            slidesPerGroup: 1,
          },
        }}
      >
        {data.map((e, i) => (
          <SwiperSlide key={i} style={{ height: 'auto' }}>
            <HousingCard data={e} isProject={false} />
          </SwiperSlide>
        ))}
      </Swiper>

      <StyledButton
        variant="outlined"
        disabled={IsEnd}
        onClick={() => swiperRef.current?.slideNext()}
        className="navigation-button right"
        aria-label="Next slide"
      >
        <SwiperArrowRight width={24} height={24} aria-hidden="true" />
      </StyledButton>
    </CarouselContainer>
  );
};
